var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sfcNormalNodeContainer",
      class: { vertical: _vm.vertical },
    },
    [
      _c(
        "div",
        { staticClass: "sfcNormalNodeWrap" },
        [
          _c(
            "div",
            {
              staticClass: "sfcNormalNodeContentWrap",
              on: {
                mouseenter: function ($event) {
                  $event.stopPropagation()
                  return _vm.onContentMouseenter($event)
                },
                mouseleave: function ($event) {
                  $event.stopPropagation()
                  return _vm.onContentMouseleave($event)
                },
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.onContentClick($event)
                },
              },
            },
            [
              _c("SFCNodeContent", { attrs: { data: _vm.data } }),
              _vm.showDeleteBtn && !_vm.readonly
                ? _c("SFCDeleteNode", { on: { click: _vm.onDeleteNode } })
                : _vm._e(),
            ],
            1
          ),
          _c("SFCArrowLine", { attrs: { data: _vm.data } }, [
            _vm._v("ArrowLine"),
          ]),
          _c("SFCAddNode", {
            attrs: {
              nodeList: _vm.nodeList,
              nodeData: _vm.data,
              btnType: _vm.isMouseEnter ? "dot" : "",
            },
          }),
        ],
        1
      ),
      _vm._l(_vm.data.nodeList || [], function (node) {
        return _c("SFCNode", {
          key: node.id,
          attrs: {
            nodeList: _vm.data.nodeList,
            data: node,
            isMouseEnter: _vm.isMouseEnter,
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }